<template>
  <div>
    <Navbar />

    <div class="complaints-container" v-if="countryCode === 'GR'">
      <div class="complaints-content">
        <h1>
          {{ $t('complaintsReportPage.countryCodeGR.title') }}
        </h1>
        <p class="subtitle">{{ $t('complaintsReportPage.year2025') }}</p>

        <div class="section">
          <p>
            {{ $t('complaintsReportPage.countryCodeGR.intro') }}
          </p>
          <p>
            {{ $t('complaintsReportPage.countryCodeGR.summaryIntro') }}
          </p>
        </div>
        <div class="section">
          <table class="complaints-table">
            <thead>
              <tr>
                <th colspan="7">
                  {{ $t('complaintsReportPage.countryCodeGR.companyService') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('complaintsReportPage.complaintCategories') }}</td>
                <td>{{ $t('complaintsReportPage.totalCases') }}</td>
                <td>{{ $t('complaintsReportPage.completeCases') }}</td>
                <td>{{ $t('complaintsReportPage.pendingCases') }}</td>
                <td>{{ $t('complaintsReportPage.avgHandlingTime') }}</td>
                <td>{{ $t('complaintsReportPage.compensationResolution') }}</td>
                <td>{{ $t('complaintsReportPage.eedResolution') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.lostItems') }}</td>
                <td>2</td>
                <td>2</td>
                <td>0</td>
                <td>{{ $t('complaintsReportPage.countryCodeGR.partnerPlatformHandling') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.damageDestruction') }}</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.deliveryDelay') }}</td>
                <td>13</td>
                <td>13</td>
                <td>0</td>
                <td>{{ $t('complaintsReportPage.countryCodeGR.deliveryDelay2Days') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.deliveryIssues') }}</td>
                <td>6</td>
                <td>6</td>
                <td>0</td>
                <td>{{ $t('complaintsReportPage.countryCodeGR.deliveryDelay3Days') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.poorService') }}</td>
                <td>2</td>
                <td>2</td>
                <td>0</td>
                <td>{{ $t('complaintsReportPage.countryCodeGR.deliveryDelay1Day') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t('complaintsReportPage.countryCodeGR.otherNonPostalIssues') }}
                </td>
                <td>1</td>
                <td>1</td>
                <td>0</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
                <td>{{ $t('complaintsReportPage.no') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.otherCompaniesComplaints') }}</td>
                <td>4</td>
                <td>4</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeGR.totalHermesComplaints') }}</td>
                <td colspan="6">28</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="complaints-container" v-else>
      <div class="complaints-content">
        <h1>
          {{ $t('complaintsReportPage.countryCodeElse.title') }}
        </h1>
        <p class="subtitle">{{ $t('complaintsReportPage.year2025') }}</p>

        <div class="section">
          <p>
            {{ $t('complaintsReportPage.countryCodeElse.intro') }}
          </p>
          <p>
            {{ $t('complaintsReportPage.countryCodeElse.summaryIntro') }}
          </p>
        </div>
        <div class="section">
          <table class="complaints-table">
            <thead>
              <tr>
                <th colspan="7">
                  {{ $t('complaintsReportPage.countryCodeElse.companyService') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('complaintsReportPage.complaintCategories') }}</td>
                <td>{{ $t('complaintsReportPage.totalCases') }}</td>
                <td>{{ $t('complaintsReportPage.completeCases') }}</td>
                <td>{{ $t('complaintsReportPage.pendingCases') }}</td>
                <td>{{ $t('complaintsReportPage.avgHandlingTime') }}</td>
                <td>{{ $t('complaintsReportPage.compensationResolution') }}</td>
                <td>{{ $t('complaintsReportPage.eedResolution') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.lostItems') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.damage') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.deliveryDelay') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.deliveryIssues') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.poorService') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t('complaintsReportPage.countryCodeElse.otherNonPostalIssues') }}
                </td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.otherCompaniesComplaints') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
                <td>{{ $t('complaintsReportPage.na') }}</td>
              </tr>
              <tr>
                <td>{{ $t('complaintsReportPage.countryCodeElse.totalComplaints') }}</td>
                <td colspan="6">{{ $t('complaintsReportPage.na') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="section">
          <p>
            {{ $t('complaintsReportPage.countryCodeElse.commitmentText') }}
            <a href="https://www.skroutzlastmile.cy">{{ 'https://www.skroutzlastmile.cy' }}</a>
            {{ $t('complaintsReportPage.countryCodeElse.phoneContactText') }}
            <a href="tel:24024047">24 024047</a>.
          </p>
          <p>
            {{ $t('complaintsReportPage.countryCodeElse.regulatorContactText') }}
          </p>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Navbar from '../pages-sections/Navbar.vue';
import Footer from '../pages-sections/Footer.vue';

export default {
  name: 'ComplaintsReportPage',
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      countryCode: process.env.VUE_APP_COUNTRY_CODE,
    };
  },
};
</script>

<style scoped>
.complaints-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.complaints-content {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

h1 {
  color: #212121;
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}

.subtitle {
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 30px;
}

.section {
  margin-bottom: 30px;
}

p {
  line-height: 1.6;
  color: #333;
  margin-bottom: 15px;
}

.complaints-table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 14px;
}

.complaints-table th,
.complaints-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}

.complaints-table th {
  background-color: #f8f8f8;
  color: #333;
  font-weight: 600;
  text-align: center;
}

.complaints-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

@media screen and (max-width: 768px) {
  .complaints-container {
    padding: 20px 10px;
  }

  .complaints-content {
    padding: 20px;
  }

  h1 {
    font-size: 20px;
  }

  .complaints-table {
    font-size: 12px;
  }

  .complaints-table th,
  .complaints-table td {
    padding: 8px 10px;
  }

  .complaints-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
</style>
